import sum from "lodash/sum";
// dang bro what is this? a java method name?
const adSettingFieldsFromTargetingOptions = (prefix, campaign) => {
  let fields = [
    { targetingFieldName: "preRoll", adSettingField: "PreRollCPM" },
    { targetingFieldName: "midRoll", adSettingField: "MidRollCPM" },
    { targetingFieldName: "postRoll", adSettingField: "PostRollCPM" },
  ];
  if (campaign?.targetingOptions) {
    fields = fields.filter(
      ({ targetingFieldName, AdSettingField }) => campaign.targetingOptions[targetingFieldName]
    );
  }
  return fields.map(({ adSettingField }) => prefix + adSettingField);
};

export const getAverageCPMFromShow = (show, campaign) => {
  const advertisingSettings = show?.advertisementSettings;
  if (!advertisingSettings) {
    return 0;
  }

  const campaignStyle = campaign.style;

  let nonZeroCPMs = [];
  if (campaignStyle === "hostRead") {
    nonZeroCPMs = nonZeroCPMs.concat(adSettingFieldsFromTargetingOptions("hostRead", campaign));
  } else if (campaignStyle === "campaignAudio") {
    nonZeroCPMs = nonZeroCPMs.concat(adSettingFieldsFromTargetingOptions("preRecorded", campaign));
  }

  nonZeroCPMs = nonZeroCPMs.map(fieldName => advertisingSettings[fieldName]).filter(a => a);

  if (!nonZeroCPMs.length) return 0;
  return Math.floor(sum(nonZeroCPMs) / nonZeroCPMs.length);
};

/*
  Calculates how many impressions we expect an Ad on a show to receive.
  Depends on the campaign style and budget. Higher budget => More Impressions
  Different campaign styles have different CPMs.
 */
export const getEstimatedImpressionsForShow = (campaign, show, budgetInCents) => {
  if (!campaign) return 0;
  const CPM = getAverageCPMFromShow(show, campaign);
  return CPM ? Math.floor((budgetInCents * 1000) / CPM) : 0;
};

export const getDurationInDays = (campaign, show, budget) => {
  const impressions = getEstimatedImpressionsForShow(campaign, show, budget);
  return show?.estimatedWeeklyDownloads
    ? Math.ceil(impressions / (show.estimatedWeeklyDownloads / 7))
    : 0;
};
